// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Whiteboard } from './components/Whiteboard.jsx';
import { Editor } from './components/Editor.jsx';
import { Login } from './components/Login.jsx'; // Import Login
import { ProtectedRoute } from './components/ProtectedRoute.jsx'; // Import Guard
import { useRulesData } from './hooks/useRulesData';

const PublicDashboard = () => {
  const { allRulesData, broadcasters, loading, error } = useRulesData();

  if (loading) return <div className="App">Chargement...</div>;
  if (error) return <div className="App">Erreur: {error.message}</div>;

  return (
    <div className="App">
      <Whiteboard 
        allRulesData={allRulesData} 
        broadcasters={broadcasters} 
      />
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<PublicDashboard />} />
        
        {/* Login Route */}
        <Route path="/login" element={<Login />} />

        {/* Protected Admin Route */}
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <Editor />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;